import { gql } from '@apollo/client';

export const findByIdPartnerCompanyRegistrationQuery = gql`
  query findByIdPartnerCompanyRegistrationQuery($_id: MongoID!) {
    findByIdPartnerCompanyRegistrationQuery(_id: $_id) {
      _id
      title
      founderEmail
      founderPhone
      platformCompanyId
      isActivated
      isRemoved
    }
  }
`;
